/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {DialogItem} from './dialog-item';

export class DialogData {
  id: number;
  dialogItem: DialogItem;
  checked: boolean;
}
